module.exports = __webpack_public_path__ + "static/media/cuatomers.8f3a0699.png";